/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  getCreditCardLoanById,
  getAllAdmins,
} from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import { FaEdit } from "react-icons/fa";
import { Row, Col, Button } from "react-bootstrap";

const EditCreditViewModal = ({ isOpen, onClose, loanId }) => {
  const { adminId, adminName } = useContext(AuthContext);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    created_id: "",
    created_by: "",
    assigned_to: "",
    status: "",
    employee_type: "",
    rejected_reason: "",
    name: "",
    mobile: "",
    email: "",
    address: "",
    state: "",
    city: "",
    pincode: "",
    gender: "",
    date_of_birth: "",
    occupation: "",
    highest_education: "",
    marital_status: "",
    credit_score: "",
    own_house: "",
    monthly_income: "",
    mortgage_payment_monthly: "",
    insure_credit_card: "",
    pan: null,
    aadhar: null,
    photo: null,
    bank_account: null,
    itr: null,
    gst_others: null,
  });

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await getAllAdmins();
        const filteredAgents = response.filter(
          (admin) => admin.role === "employee"
        );
        setAgents(filteredAgents);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching agents:", error);
      }
    };

    fetchAgents();
  }, []);

  useEffect(() => {
    const fetchLoanData = async () => {
      if (loanId && isOpen) {
        try {
          const loan = await getCreditCardLoanById(loanId);

          setFormData({
            created_id: loan.created_id || "",
            created_by: loan.created_by || "",
            assigned_to: loan.assigned_to || "",
            status: loan.status || "",
            employee_type: loan.employee_type || "",
            rejected_reason: loan.rejected_reason || "",
            name: loan.name || "",
            mobile: loan.mobile || "",
            email: loan.email || "",
            address: loan.address || "",
            city: loan.city || "",
            state: loan.state || "",
            pincode: loan.pincode || "",
            gender: loan.gender || "",
            date_of_birth: loan.date_of_birth
              ? new Date(loan.date_of_birth).toISOString().split("T")[0]
              : "",
            occupation: loan.occupation || "",
            highest_education: loan.highest_education || "",
            marital_status: loan.marital_status || "",
            credit_score: loan.credit_score || "",
            own_house: loan.own_house || "",
            monthly_income: loan.monthly_income?.toString() || "",
            mortgage_payment_monthly:
              loan.mortgage_payment_monthly?.toString() || "",
            insure_credit_card: loan.insure_credit_card || "",
            pan: loan.pan || null,
            aadhar: loan.aadhar || null,
            photo: loan.photo || null,
            bank_account: loan.bank_account || null,
            itr: loan.itr || null,
            gst_others: loan.gst_others || null,
          });
        } catch (error) {
          console.error("Error fetching credit card loan data:", error);
        }
      }
    };

    fetchLoanData();
  }, [loanId, adminId, adminName]);

  const handleEditClick = () => {
    navigate(`/edit-creditcard-loan/${loanId}`);
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay-edit')) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-edit" onClick={handleOverlayClick}>
      <div className="modal-content-edit">
        <h3 className="edit-title">
          CreditCard
          <span className="action-icon">
            <FaEdit
              className="edit-loan"
              style={{ cursor: "pointer" }}
              onClick={handleEditClick}
            />
          </span>
        </h3>
        <div className="form-content-section">
          <div className="step-sections-personal-details-sections">
            <h4>Personal Details</h4>
            <div className="form-row-step">
              <strong>Agent ID:</strong>
              <div className="value">{formData.created_id}</div>
            </div>

            <div className="form-row-step">
              <strong>Agent:</strong>
              <div className="value">{formData.created_by}</div>
            </div>

            <div className="form-row-step">
              <strong>Assign to:</strong>
              <div className="value">{formData.assigned_to}</div>
            </div>

            <div className="form-row-step">
              <strong>Lead Status:</strong>
              <div className="value">{formData.status}</div>
            </div>

            {formData.status === "Rejected" && (
              <div className="form-row-step">
                <strong>Rejected reason:</strong>
                <div className="value">{formData.rejected_reason}</div>
              </div>
            )}

            <div className="form-row-step">
              <strong>Name:</strong>
              <div className="value">{formData.name}</div>
            </div>

            <div className="form-row-step">
              <strong>Gender:</strong>
              <div className="value">{formData.gender}</div>
            </div>

            <div className="form-row-step">
              <strong>Date of Birth:</strong>
              <div className="value">{formData.date_of_birth}</div>
            </div>

            <div className="form-row-step">
              <strong>Mobile:</strong>
              <div className="value">{formData.mobile}</div>
            </div>

            <div className="form-row-step">
              <strong>Email:</strong>
              <div className="value">{formData.email}</div>
            </div>

            <div className="form-row-step">
              <strong>Address:</strong>
              <div className="value">{formData.address}</div>
            </div>

            <div className="form-row-step">
              <strong>State:</strong>
              <div className="value">{formData.state}</div>
            </div>

            <div className="form-row-step">
              <strong>City:</strong>
              <div className="value">{formData.city}</div>
            </div>

            <div className="form-row-step">
              <strong>Pincode:</strong>
              <div className="value">{formData.pincode}</div>
            </div>

            <div className="form-row-step">
              <strong>Marital Status:</strong>
              <div className="value">{formData.marital_status}</div>
            </div>

            <div className="form-row-step">
              <strong>Employee Type:</strong>
              <div className="value">{formData.employee_type}</div>
            </div>

            <div className="form-row-step">
              <strong>Occupation:</strong>
              <div className="value">{formData.occupation}</div>
            </div>

            <div className="form-row-step">
              <strong>Highest Education:</strong>
              <div className="value">{formData.highest_education}</div>
            </div>

            <h4>Loan Details</h4>
            <div className="form-row-step">
              <strong>Are you a homeowner, renter, or other?:</strong>
              <div className="value">{formData.own_house}</div>
            </div>

            <div className="form-row-step">
              <strong>Already have a credit card?:</strong>
              <div className="value">{formData.insure_credit_card}</div>
            </div>

            <div className="form-row-step">
              <strong>Credit Card Limit:</strong>
              <div className="value">{formData.credit_score}</div>
            </div>
          </div>

          <div className="button-sections">
            <Row>
              <Col className="text-end">
                <Button
                  className="custom-back-button"
                  type="button"
                  onClick={onClose}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCreditViewModal;
